import React from 'react';
import Skeleton from '../../Skeleton/Skeleton';
import styles from './NavigationItem.module.css';

export const config = {
  img: {
    width: '24px',
    height: '24px',
    count: 1,
  },
  title: {
    width: '120px',
    height: '22px',
    style: {
      marginTop: '16px',
    },
    count: 1,
  },
};

export const mobileConfig = config;

export const ImgSkeleton = ({ isDesktop = true }) => (
  <Skeleton config={isDesktop ? config.img : mobileConfig.img} />
);
export const TitleSkeleton = ({ isDesktop = true }) => (
  <Skeleton config={isDesktop && config.title} />
);

export function NavigationItemSkeleton() {
  return (
    <div className={styles['NavigationItem']}>
      <div className={styles['icon']}>
        <ImgSkeleton />
      </div>
      <div className={styles['text']}>
        <TitleSkeleton />
      </div>
    </div>
  );
}

export default NavigationItemSkeleton;
